module.exports = __webpack_public_path__ + "static/DigitalVideo-2edf5e71d7ac46b63ac4ca73c8122862.mp4";